import React from 'react'
import { isEqual } from 'libraries/lodash'
import cx from 'classnames'
import Icon from 'components/shared/Icon'

const SortBy = ({ sortingOptions, activeSorting, urlGenerator }) => (
  <div className='mb4 pv3 '>
    <div className='bb'>
      <h3 className='mb2 f4 fw6 black lh-copy mt4'>
        Sort by
      </h3>
    </div>
    {sortingOptions.map(option => (
      <a
        href={urlGenerator(option)}
        className='db mt2 f5 black no-underline ca-filter-link hover-no-underline w-max-content'
        key={option}
      >
        <div className='flex items-center'>
          <Icon
            className={cx('w6 mr4', { 'dark-sea-green': isEqual(option, activeSorting) })}
            name={isEqual(option, activeSorting) ? 'icon-radiobox-marked' : 'icon-radiobox-blank'}
          />
          <span className='black'>{option}</span>
        </div>
      </a>
    ))}
  </div>
)

export default SortBy
